import { makeStyles } from '@material-ui/styles';

import { TextButton } from '@bizzabo/design-system';

import useTypeTracking from '../../../../analytics';
import { LocationType } from '../../types';
import { ScheduledMeeting } from '../../types';

interface MeetingLinkBtnProps {
    meeting: ScheduledMeeting;
    isHost: boolean;
    meetingLinkClick: () => void;
}

const MeetingLinkBtn: React.FC<MeetingLinkBtnProps> = ({ meeting, isHost, meetingLinkClick }) => {
    const classes = useStyles();
    const { trackClickEvent } = useTypeTracking();

    const text =
        meeting.locationType === LocationType.Physical ? 'Join virtually' : 'Virtual meeting';

    const meetingLinkClickHandle = () => {
        trackClickEvent({
            subCategory: 'MEETING_LINK_CLICKED',
            description: {
                meeting_id: meeting.id,
                is_host: isHost,
            },
        });
        meetingLinkClick();
    };

    return (
        <TextButton className={classes.meetingLink} onClick={meetingLinkClickHandle}>
            {text}
        </TextButton>
    );
};

const useStyles = makeStyles(
    theme => ({
        meetingLink: {
            ...theme.typography.t81,
            color: theme.customization.background.G10,
            display: 'inline',
            padding: 0,
        },
    }),
    { classNamePrefix: 'meetings-meeting-link-button' }
);

export default MeetingLinkBtn;
